import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var PageFooter = styled.footer.withConfig({
  displayName: "PageFooter",
  componentId: "sc-oyvblh-0"
})(["background-color:", ";width:100%;padding:0 40px 30px;", ";font-weight:500;", ";color:#fff;a{display:block;color:#fff;}", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.footerColor;
}, getFont(0, 'compact'), fontSmoothing, function (_ref2) {
  var withConversations = _ref2.withConversations;
  return withConversations && "padding-bottom: 80px";
}, maxMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  "])), function (_ref3) {
  var withConversations = _ref3.withConversations;
  return withConversations && "padding-bottom: 100px";
}));